<template>
  <div>
    <v-layout>
      <v-flex xs2>
        <v-text-field
          label="Start time"
          v-model="startTime"
          @input="onChangeInput"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          label="End time"
          v-model="endTime"
          @input="onChangeInput"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          label="Title"
          v-model="title"
          @input="onChangeInput"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          label="Description"
          v-model="description"
          @input="onChangeInput"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-btn 
          color="primary" 
          fab 
          dark
          v-if="index === totalIndex - 1"
          @click.stop="addToArray"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn 
          color="primary" 
          fab 
          dark
          v-else
          @click.stop="removeDataToArray(index)"
        >
          <v-icon>remove</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      startTime: '',
      endTime: '',
      title: '',
      description: ''
    }
  },
  props: {
    index: {
      type: Number
    },
    totalIndex: {
      type: Number
    },
    addToArray: {
      type: Function
    },
    removeToArray: {
      type: Function
    },
    dataStartTime: {
      type: String
    },
    dataEndTime: {
      type: String
    },
    dataTitle: {
      type: String
    },
    dataDescription: {
      type: String
    },
    updateMultipleSegment: {
      type: Function
    }
  },
  methods: {
    removeDataToArray (index) {
      this.removeToArray(index)
    },
    onChangeInput () {
      let obj = {
        start_time: this.startTime,
        end_time: this.endTime,
        title: this.title,
        description: this.description
      }
      this.updateMultipleSegment(obj, this.index)
    }
  },
  watch: {
    dataStartTime: function (val) {
      this.startTime = val
    },
    dataEndTime: function (val) {
      this.endTime = val
    },
    dataTitle: function (val) {
      this.title = val
    },
    dataDescription: function (val) {
      this.description = val
    }
  },
  mounted () {
    this.startTime = this.dataStartTime
    this.endTime = this.dataEndTime
    this.title = this.dataTitle
    this.description = this.dataDescription
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/multipleSegment.vue